import React from 'react'
import {useDropzone} from 'react-dropzone'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, IconButton, Typography} from '@material-ui/core'
import {ReactComponent as FileUploadIcon} from '../../../../../../images/upload-document.svg'
import Close from '@material-ui/icons/Close'

// using hook API
const useStyles = makeStyles(theme => ({
    boundaryBox: {
        display: 'flex',
        flexDirection: 'column',
        margin: '15px 0',
        fontSize: '0.825rem',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    rotateIcon: {
        margin: '-15px 5px 0 0',
        height: '140px',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        border: '2px dashed #DBDBDB',
        padding: '10px',
    },
    fileList: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        wordBreak: 'break-word',
    },
    fileListRemove: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        wordBreak: 'break-word',
        color: theme.palette.error.borderColor,
    },
    removeButton: {
        padding: '0 0 10px 5px',
    },
}))

const BatchUploadFileSearchView = props => {
    const classes = useStyles()

    const {
        myFiles,
        setMyFiles,
        rejectedFiles,
        setRejectedFiles,
        onDropAccepted,
        onDropRejected,
        detectChange,
    } = props

    const {getRootProps, getInputProps} = useDropzone({
        onDropAccepted,
        onDropRejected,
        accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
    })

    const removeFile = file => () => {
        const newFiles = [...myFiles]
        newFiles.splice(newFiles.indexOf(file), 1)
        setMyFiles(newFiles)
    }

    const removeAll = () => {
        setMyFiles([])
    }

    const removeRejectedFile = file => () => {
        const newFiles = [...rejectedFiles]
        newFiles.splice(newFiles.indexOf(file), 1)
        setRejectedFiles(newFiles)
    }

    const removeRejectedAll = () => {
        setRejectedFiles([])
    }

    const files = myFiles.map(file => (
        <li key={file.path}>
            <Box className={classes.fileList}>
                {file.path} - {file.size} bytes{' '}
                <IconButton
                    onClick={removeFile(file)}
                    className={classes.removeButton}
                >
                    <Close style={{color: '#000000'}} />
                </IconButton>
            </Box>
        </li>
    ))

    const rejectedfileItems = rejectedFiles.map(file => (
        <li key={'rejected-' + file.file.path}>
            <Box className={classes.fileList}>
                {file.file.path} - {file.errors[0].code}{' '}
                <IconButton
                    onClick={removeRejectedFile(file)}
                    className={classes.removeButton}
                >
                    <Close style={{color: '#000000'}} />
                </IconButton>
            </Box>
        </li>
    ))

    const displayFilename = files.length > 0 ? true : false
    const displayRejectedFilename = rejectedfileItems.length > 0 ? true : false

    if (displayFilename || displayRejectedFilename) {
        detectChange.current = true
    } else {
        detectChange.current = false
    }

    return (
        <>
            <Box className={classes.boundaryBox}>
                <Typography
                    variant="subtitle1"
                    style={{color: '#098447', margin: '5px 0'}}
                >
                    Step 2 of 4: Upload Spreadsheet
                </Typography>
                <div
                    {...getRootProps({className: 'dropzone'})}
                    className={classes.container}
                >
                    <input {...getInputProps()} />
                    <FileUploadIcon className={classes.rotateIcon} />
                    <Typography
                        align="center"
                        variant="body2"
                        style={{color: '#707070'}}
                    >
                        <br />
                        Drop an Excel file here or click to choose from your
                        computer. <br />
                        <br />
                        We accept .xls or .xlsx
                        <br />
                    </Typography>
                </div>
                {displayFilename ? (
                    <aside>
                        <h4>Accepted Files</h4>
                        <ul>{files}</ul>
                        {files.length > 1 && (
                            <Button
                                variant="outlined"
                                size="small"
                                className={classes.removeALLButton}
                                onClick={removeAll}
                            >
                                Remove All Accepted
                            </Button>
                        )}
                    </aside>
                ) : null}
                {displayRejectedFilename ? (
                    <aside>
                        <h4>Rejected Files. Please remove.</h4>
                        <ul>{rejectedfileItems}</ul>
                        {rejectedfileItems.length > 1 && (
                            <Button
                                variant="outlined"
                                size="small"
                                className={classes.removeAllButton}
                                onClick={removeRejectedAll}
                            >
                                Remove All Rejected
                            </Button>
                        )}
                    </aside>
                ) : null}
            </Box>
        </>
    )
}

export default BatchUploadFileSearchView
